import React from "react";
import {Container} from '@material-ui/core';

export const MyContainer = ({className, ...props}) => (
    <Container className={className} maxWidth='md' {...props} />
);